// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { ShapeElement } from './ShapeElement';
import { NodeShape } from './NodeShape';
/**
 * 区域图形 实体类
 * 节点内部的区域图形
 */
export class ScopeShape extends ShapeElement {
  /** IsExpend : 图形是否是展开状态，默认true */
  private _isExpend: boolean;

  /** 设置：IsExpend */
  public get isExpend() {
    return this._isExpend;
  }

  /** 获取：IsExpend */
  public set isExpend(value: boolean) {
    this._isExpend = value;
  }

  /** 编码 : 区域编码，前端根据编码自行设置显示名称 */
  private _code: string;

  /** 设置：编码 */
  public get code() {
    return this._code;
  }

  /** 获取：编码 */
  public set code(value: string) {
    this._code = value;
  }

  /** 顺序号 : 区域的顺序号 */
  private _sequence: number;

  /** 设置：顺序号 */
  public get sequence() {
    return this._sequence;
  }

  /** 获取：顺序号 */
  public set sequence(value: number) {
    this._sequence = value;
  }

  /** 节点图形 的ID */
  private _nodeShape_ID: string;

  /** 获取：节点图形 的ID */
  public get nodeShape_ID() {
    return this._nodeShape_ID;
  }

  /** 设置：节点图形 的ID */
  public set nodeShape_ID(value: string) {
    this._nodeShape_ID = value;
  }

  /** 节点图形  */
  private _nodeShape: NodeShape;

  /** 获取：节点图形  */
  public get nodeShape() {
    return this._nodeShape;
  }

  /** 设置：节点图形  */
  public set nodeShape(value: NodeShape) {
    this._nodeShape = value;
    if (value !== null) {
      this.nodeShape_ID = value.id;
    } else {
      this.nodeShape_ID = '';
    }
  }

  constructor() {
    super();
    this._isExpend = true;
    this._code = '';
    this._sequence = 0;
    this._nodeShape_ID = '';
    this._nodeShape = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: ScopeShape, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.isExpend = element.isExpend;
      this.code = element.code;
      this.sequence = element.sequence;
      this.nodeShape_ID = element.nodeShape_ID;
      if (hasReference && element.nodeShape !== null) {
        this.nodeShape = element.nodeShape;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.isExpend = json.IsExpend;
    this.code = json.Code;
    this.sequence = json.Sequence;
    this.nodeShape_ID = json.NodeShape_ID;
    // if (json.NodeShape !== null) {
    //   this.nodeShape = NodeShape.Create(json.NodeShape);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.IsExpend = this.isExpend;
    json.Code = this.code;
    json.Sequence = this.sequence;
    json.NodeShape_ID = this.nodeShape_ID;
  }

  static Create(json: any): ScopeShape {
    const scopeShape = new ScopeShape();
    scopeShape.Deserialize(json);
    scopeShape.json = json;
    return scopeShape;
  }
}
